// src/Components/Drawer/PhotosTab/SortableImageItem.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import { SoundWaveIcon } from '../../../assets/icons/CustomIcons';

export const SortableImageItem = ({
  item,
  index,
  handleDragStart,
  handleDragEnter,
  handleDragEnd,
  handleClick,
  isSelected,
}) => {
  // AMENDED: Vastly expanded extension matching to prevent false images
  const isVideo =
    item.type === 'video' ||
    (typeof item.title === 'string' &&
      item.title.match(/\.(mp4|mov|webm|avi|mkv|wmv|flv|mts|m4v)/i)) ||
    (typeof item.img === 'string' &&
      item.img.match(/\.(mp4|mov|webm|avi|mkv|wmv|flv|mts|m4v)/i));

  // Regex for Audio - Added m4a, aac
  const isAudio =
    item.type === 'audio' ||
    (typeof item.title === 'string' && item.title.match(/\.(mp3|wav|ogg|m4a|aac)/i)) ||
    (typeof item.img === 'string' && item.img.match(/\.(mp3|wav|ogg|m4a|aac)/i));

  // Trap for text-only or empty media payloads
  const isTextOrPlaceholder =
    item.type === 'text' || item.type === 'placeholder' || !item.img;

  return (
    <Box sx={{ width: '100%', aspectRatio: '1/1' }}>
      {/* WRAPPER DIV: Added class for drag exclusion. Handles Click logic and Border effect */}
      <div
        className='sortable-image-item' // AMENDED: Excludes this div from CustomDrawer dragging
        draggable
        onDragStart={(e) => handleDragStart(e, index)}
        onDragEnter={(e) => handleDragEnter(e, index)}
        onDragEnd={handleDragEnd}
        onDragOver={(e) => e.preventDefault()}
        onClick={(e) => {
          e.stopPropagation();
          if (handleClick) handleClick(e, item.id);
        }}
        style={{
          width: '100%',
          height: '100%',
          cursor: 'pointer',
          borderRadius: '8px',
          position: 'relative',
          transition: 'all 0.2s ease',
          // AMENDED: Halved border width (2px). Removed white background for transparency.
          border: isSelected ? '2px solid #0055ff' : '2px solid transparent',
          padding: isSelected ? '8px' : '0px',
          backgroundColor: 'transparent',
          boxSizing: 'border-box',
        }}>
        {/* INNER CONTAINER: Actually holds and crops the media */}
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '4px',
            overflow: 'hidden',
            position: 'relative',
            backgroundColor: isTextOrPlaceholder
              ? '#63c2e8'
              : isVideo
                ? '#000'
                : isAudio
                  ? '#f5f5f5'
                  : 'transparent',
          }}>
          {isTextOrPlaceholder ? (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 1,
              }}>
              <Typography
                sx={{
                  color: '#fff',
                  fontStyle: 'italic',
                  fontSize: '0.8rem',
                  textAlign: 'center',
                }}>
                No Media Available
              </Typography>
            </Box>
          ) : isAudio ? (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                p: 1,
              }}>
              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  opacity: 0.6,
                }}>
                <SoundWaveIcon sx={{ width: '50%', height: '50%' }} />
              </Box>
              <audio
                src={item.img}
                controls
                style={{
                  width: '100%',
                  height: '35px',
                  marginTop: 'auto',
                }}
              />
            </Box>
          ) : isVideo ? (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#000',
              }}>
              <video
                src={item.img}
                preload='metadata'
                controls
                playsInline
                // *** THE FIX: Force the browser to render frame 0.1 ***
                onLoadedMetadata={(e) => {
                  e.target.currentTime = 0.1;
                }}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          ) : (
            <img
              src={item.img}
              alt={item.title || 'Media'}
              loading='lazy'
              draggable='false'
              style={{
                height: '100%',
                width: '100%',
                objectFit: 'cover', // Ensures horizontal/vertical images fill the square completely
                display: 'block',
                pointerEvents: 'none',
                userSelect: 'none',
              }}
            />
          )}
        </Box>
      </div>
    </Box>
  );
};

export default SortableImageItem;
